import Vue from 'vue';
import Vuex from 'vuex';
import UserModule from './modules/user';
import FoodModule from './modules/food';
import AppModule from './modules/app';
import TimeSchedulerModule from './modules/time-scheduler';
import ProductCustomizerModule from './modules/product-customizer';
import CartModule from './modules/cart';
import createPersistedState, { Storage } from 'vuex-persistedstate';
import updateCurrentTimeSlot from './plugins/update-current-time-slot';
import { recursiveDateConversion } from '@/utils/utilities';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        app: AppModule,
        user: UserModule,
        food: FoodModule,
        timescheduler: TimeSchedulerModule,
        product_customizer: ProductCustomizerModule,
        cart: CartModule
    },
    plugins: [
        updateCurrentTimeSlot(),
        createPersistedState({
            paths: [
                'cart.products',
                'cart.status',
                'cart.createAccount',
                'cart.registrationError',
                'cart.maxOrderProducts',
                'cart.businessName',
                'cart.deliveryInstructions',
                'cart.saveAddress',
                'timescheduler.retrievalMethod'
            ],
            getState: (key: string, storage: Storage) => {
                const storageItem = JSON.parse((<any>storage).getItem(key));
                if (storageItem) {
                    const now = new Date();
                    const storageDate = new Date(storageItem.date);
                    storageDate.setTime(storageDate.getTime() + 60 * 60 * 1000);
                    if (storageDate.getTime() >= now.getTime()) {
                        return recursiveDateConversion(storageItem.content);
                    }
                }
            },
            setState: (key: string, value: any, storage: Storage) => {
                const now = new Date();
                const storageItem = {
                    date: now.getTime(),
                    content: value
                }
                return storage.setItem(key, JSON.stringify(storageItem));
            }
        })
    ]
});
